module.exports = __webpack_public_path__ + "static/img/post_5.4ad383a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_5.png
// module id = mfBf
// module chunks = 0